import type { IconData } from '@stacksjs/iconify-core'

export const moneyCreditCard: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 2H0v3h16z\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16 6.5H0V14h16zM11.75 11a1.25 1.25 0 1 1 2.5 0a1.25 1.25 0 0 1-2.5 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default moneyCreditCard
